export default function (state = [], action) {
  if (action.type.substr(action.type.length - 7) === 'PENDING') {
    return { loading: true }
  } else if (action.type.substr(action.type.length - 9) === 'FULFILLED') {
    return { loading: false }
  } else {
    return state
  }
}
